import CityPageTemplate from "../city-template/CityPageTemplate";
import { orangeConfig } from "./data";

export default function OrangePage() {
  return <CityPageTemplate config={orangeConfig} />;
}